'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Skeleton } from '@common/components';
import { SvgBookmarkFill, SvgChatbubbleTypingFill } from '@common/icon';
import { assert, cn } from '@core/utils';
import { BOOKMARK_TYPE } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES, SELECTOR } from '@/constants';
import { useBookmark } from '@/hooks/useBookmark';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { CONTENT_CATEGORY, GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { extractDate } from '@/utils/extractDate';
export type PolicyCardProps = {
  isLoading?: boolean;
  id?: number;
  idIdx?: string;
  imageUrl?: string;
  name?: string;
  endAt?: string;
  dday?: string;
  benefit?: string;
  commentCount?: number;
  border?: boolean;
  isBookmarked?: boolean;
  bookmarkCount?: number;
  agencyId?: number;
  agency?: string;
  variant?: 'default' | 'scrap';
  /** 클릭 이벤트가 있을 때에는 기본 기능인 링크 이동을 방지 */
  onClick?: () => void;
};
const BOOKMARK = '스크랩';
const COMMENT = '댓글';
export const PolicyCard = t0 => {
  const $ = _c(46);
  const {
    endAt,
    name,
    dday,
    benefit,
    bookmarkCount,
    commentCount,
    isBookmarked: t1,
    isLoading,
    onClick,
    idIdx,
    border,
    imageUrl,
    id,
    agency,
    variant: t2
  } = t0;
  const isBookmarked = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  const router = useCustomRouter();
  let t3;
  if ($[0] !== endAt) {
    t3 = endAt ? extractDate(endAt) : undefined;
    $[0] = endAt;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const date = t3;
  let t4;
  if ($[2] !== idIdx) {
    t4 = ROUTES.POLICY_DETAIL.pathname({
      idIdx: idIdx ?? ""
    });
    $[2] = idIdx;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const href = t4;
  const {
    bookmark
  } = useBookmark();
  const isScrap = variant === "scrap";
  const t5 = isScrap ? "gap-16 px-20 py-16" : "gap-12 rounded-small bg-Gray-white px-15 pb-14 pt-16";
  const t6 = !isScrap && border && "border border-Gray-300";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = cn("flex flex-col", t5, t6);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== id || $[8] !== isLoading || $[9] !== name || $[10] !== onClick) {
    t8 = e => {
      trackGtmEvent(GTM_EVENT_TYPE.SELECT_CONTENT, {
        content_name: name ?? "",
        content_category: CONTENT_CATEGORY.POLICY,
        content_id: id?.toString() ?? ""
      });
      if (isLoading || onClick) {
        e.preventDefault();
      }
      onClick?.();
    };
    $[7] = id;
    $[8] = isLoading;
    $[9] = name;
    $[10] = onClick;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== imageUrl || $[13] !== isLoading || $[14] !== isScrap || $[15] !== name) {
    t9 = isLoading ? <Skeleton className="size-52 rounded-medium" /> : <Image alt={name || "\uC815\uCC45 \uC774\uBBF8\uC9C0"} className={cn("size-52 rounded-large border border-Gray-300", isScrap ? "object-contain" : "object-cover p-6")} height={52} src={imageUrl} width={52} />;
    $[12] = imageUrl;
    $[13] = isLoading;
    $[14] = isScrap;
    $[15] = name;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== dday || $[18] !== isLoading || $[19] !== isScrap || $[20] !== name) {
    t10 = isLoading ? <Skeleton className="w-80" typo="body3" /> : <div className="line-clamp-2">{dday && !isScrap ? <Badge className="mr-8 inline-block h-23 text-R-400">{dday}</Badge> : null}<h4 className="inline break-keep font-500 typo-body3">{name}</h4></div>;
    $[17] = dday;
    $[18] = isLoading;
    $[19] = isScrap;
    $[20] = name;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <section className="flex items-center gap-12">{t9}{t10}</section>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== agency || $[26] !== benefit || $[27] !== bookmark || $[28] !== bookmarkCount || $[29] !== commentCount || $[30] !== date || $[31] !== endAt || $[32] !== href || $[33] !== id || $[34] !== idIdx || $[35] !== isBookmarked || $[36] !== isLoading || $[37] !== name || $[38] !== router) {
    t12 = isLoading ? <div className="flex justify-between gap-16"><div className="flex flex-1 items-center gap-10"><Skeleton className="w-100" typo="caption1" /><Skeleton className="w-80" typo="caption1" /></div><Skeleton className="w-28" typo="caption1" /><Skeleton className="w-28" typo="caption1" /></div> : <footer className="flex justify-between gap-8">{isLoading ? <div className="flex flex-1 items-center gap-10"><Skeleton className="w-100" typo="caption1" /><Skeleton className="w-80" typo="caption1" /></div> : <div className="flex flex-1 items-center gap-5 overflow-hidden text-nowrap text-Gray-600 typo-caption1">{benefit ? <p className="truncate">{benefit}</p> : null}{benefit && endAt ? <div className="h-10 w-1 bg-Gray-400" /> : null}{endAt ? <time dateTime={date}>{endAt}</time> : null}</div>}{typeof commentCount === "number" ? <button aria-label={COMMENT} className="group gap-4 text-Gray-700 flex-center typo-caption1" title={COMMENT} type="button" onClick={e_0 => {
        e_0.preventDefault();
        e_0.stopPropagation();
        router.push(href + "#" + SELECTOR.COMMENT_LIST_TOP);
      }}><SvgChatbubbleTypingFill aria-label={COMMENT} className="size-16 text-Gray-400" />{commentCount < 1000 ? commentCount : "999+"}</button> : null}{typeof bookmarkCount === "number" ? <button aria-label={BOOKMARK} className="group gap-4 text-Gray-700 flex-center typo-caption1" title={BOOKMARK} type="button" onClick={e_1 => {
        e_1.preventDefault();
        e_1.stopPropagation();
        assert(id);
        bookmark({
          bookmarkType: BOOKMARK_TYPE.POLICY,
          contentId: id,
          isBookmarked,
          idx: idIdx,
          contentName: name,
          policyAgency: agency
        });
      }}><SvgBookmarkFill aria-label={BOOKMARK} className={cn("size-16 text-Gray-400 transition-all duration-75", isBookmarked && "text-B-500")} />{bookmarkCount < 1000 ? bookmarkCount : "999+"}</button> : null}</footer>;
    $[25] = agency;
    $[26] = benefit;
    $[27] = bookmark;
    $[28] = bookmarkCount;
    $[29] = commentCount;
    $[30] = date;
    $[31] = endAt;
    $[32] = href;
    $[33] = id;
    $[34] = idIdx;
    $[35] = isBookmarked;
    $[36] = isLoading;
    $[37] = name;
    $[38] = router;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== href || $[41] !== t11 || $[42] !== t12 || $[43] !== t7 || $[44] !== t8) {
    t13 = <CustomLink className={t7} href={href} onClick={t8}>{t11}{t12}</CustomLink>;
    $[40] = href;
    $[41] = t11;
    $[42] = t12;
    $[43] = t7;
    $[44] = t8;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  return t13;
};